import { Optional } from "#types";
import { IoState } from "#store/types";
import { rangeCoversMoreThan } from "#/util/timeUtils";
import { AppConfig } from "#/config";

/**
 * evaluate if a IoState should be fetched from the server.
 *
 * @param item
 */
export function shouldRefetch(item: Optional<IoState>): boolean {
    if (!item) {
        return true;
    }

    if (item.state === "fetching") {
        // if we're still "not done", we refetch
        return true;
    }
    if (
        rangeCoversMoreThan(
            new Date(),
            item.timestamp,
            AppConfig.refetchTimeout
        )
    ) {
        // if we're done or error, but the last fetch was long ago.
        return true;
    }
    return false;
}
